// extracted by mini-css-extract-plugin
export default {"groupTabs":"GroupTabs_groupTabs__K4IKV","tabs":"GroupTabs_tabs__O+B6X","tab":"GroupTabs_tab__A9bjT","active":"GroupTabs_active__IeW84"};